export default __webpack_public_path__ + "static/media/at (1).ab995018.jpg";